
import state from './../../zviz2/zviz/state';
import DefaultController from './../../zviz2/zviz/controller';
import Group from './../../zviz2/zviz/components/group';
import Rectangle from './../../zviz2/zviz/components/rectangle';
import Defs from './../../zviz2/zviz/components/svg/defs';
import ClipPath from './../../zviz2/zviz/components/svg/clippath';
import Gradient from './../../zviz2/zviz/components/svg/lineargradient';
import StopBlueprint from './../../zviz2/zviz/components/svg/stop';
import MapBlueprint from './map';
import SVGRenderer from './../../zviz2/zviz/renderers/svg';
import {extend} from './../../zviz2/zviz/functions';
import {gradient1, gradient2, gradient3, gradient4} from './fades';
import config from './../../config';
import ThemeData from './themedata';
import GeoData from './geodata';
import SvgLoader from './../elements/svgloader';
//import {LifeCycle} from './../zviz2/zviz/cycle';
import flowModel from './../../model/flow';


class Controller extends DefaultController{

    constructor(parent, blueprint={}){

        super(parent, blueprint);

        this.type = 'svg'; 
        
        // this.setResponder('map.height', [this, this.updateChildren]);
        this.width = 0;
        this.height = 0;

        this.boundingBox = [{x: 0, y: 0}, {x: 0, y:0}];
        this.isLoading = true;

        this.svgRenderer = new SVGRenderer();
        // this.svgRenderer.rootController = this;
        this.svgRenderer.start(this, false);
        
    }

    // switch renderer, because the wrong one might be passed
    // on from the parent node.
    init(renderer){
        super.init(this.svgRenderer);
    }

    reset(blueprint, renderer=null){
        super.reset(blueprint, this.svgRenderer);
    }

    render(renderer){
        this.svgRenderer.forceGlobalUpdate = renderer.forceGlobalUpdate;
        super.render(this.svgRenderer);
    }

    remove(renderer, removeFromParent=true){
        super.remove(this.svgRenderer, removeFromParent);
        this.svgRenderer.remove(false);
        state.set('map', null);
    }



    loadData(){
        this.isLoading = false;
        let status = this.models['flow'].status;

        if(status == 'success'){
            // this.items = data.items;
            // this.links = data.links;
            this.isLoading = false;
            this.update();
        }else if(status == 'loading'){
            this.isLoading = true;
            this.updaten();
        }else if(status == 'failed'){
            this.isLoading = false;
            state.set('errorMessage', {title: 'Error loading data', description: this.models['flow'].data||''} );
            this.update();
        }
    }


    getWidth(){
        if(this.parent.renderOutput && this.parent.renderOutput.result){
            let width = this.parent.renderOutput.result.clientWidth;
            if(width !== this.width){
                this.width = width;
                this.update();
            }
        }
        return this.width || 200;
    }

    setHeight(height){
        if(this.height != height){
            this.height = height;
            this.update();           
        }
    }

    getHeight(getFullHeight=false){
        if(getFullHeight){
            return this.height + config.display.mapOffset.top + 
                    config.display.mapOffset.bottom 
        }
        return this.height || 100;
    }

    setBoundingBox(bbox){

        if(this.boundingBox[0].x != bbox[0].x || this.boundingBox[0].y != bbox[0].y ||
                this.boundingBox[1].x != bbox[1].x || this.boundingBox[1].y != bbox[1].y){
            this.boundingBox = bbox;
            this.update();
        }
    }

    getBoundingBox(){

        return this.boundingBox;
    }

} 



let Blueprint = {
    type: Controller,
    models: {
        'flow': null
    },
    listeners: [
        (ctrl) => ( ctrl.addListener(ctrl.models['flow'], [ctrl, ctrl.loadData]))
    ],
    uid: 'svg',
    properties: {
        attributes: {
            'width': (ctrl) => ( ctrl.getWidth() + 'px' ),
            'height': (ctrl) => ( (ctrl.getHeight(true)) + 'px' ), 
            'viewbox': (ctrl) => ( '0 0 ' + ctrl.getWidth() + 
                    ' ' + (ctrl.getHeight(true)) )
        }
    },
    children: [
        (parent) => (extend({
            properties: { 
                data: {
                    bbox: parent.getBoundingBox(),
                    w: parent.getWidth(),
                    h: parent.getHeight()
                }
             },
            children: [ 
                (parent) => (extend({
                    properties:{
                        attributes: {
                            'id': 'mapGradient',
                            'x1': parent.data.bbox[0].x,
                            'y1': parent.data.bbox[0].y,
                            'x2': parent.data.bbox[1].x,
                            'y2': parent.data.bbox[1].y 
                        }
                    },
                    children: [
                        extend({
                            type: StopBlueprint,
                            properties: {
                                attributes: { 'offset': '0' },
                                style: { stopColor: '#183c6a' }
                            }
                        },StopBlueprint),

                        extend({
                            properties: {
                                attributes: { 'offset': '1' },
                                style: { stopColor: '#6db6cb' }
                            }
                        }, StopBlueprint)
                    ]
                }, Gradient) ),

                (parent) => (extend({
                    properties: {
                        attributes: {
                            'id': 'mapClipPath',
                            'clipPathUnits': 'userSpaceOnUse'
                        },
                        data: {
                            width: parent.data.w,
                            height: parent.data.h,
                        }
                    },
                    children: [
                        extend({
                            properties: {
                                attributes: {
                                    'x': '0', 
                                    'y': '0', 
                                    'width': (ctrl) => ( ctrl.parent.data.width ),
                                    'height': (ctrl) => ( ctrl.parent.data.height )
                                }
                            }
                        }, Rectangle)
                    ]
                }, ClipPath) ),

                gradient1,
                gradient2,
                gradient3,
                gradient4
             ]
        }, Defs) ),

        (parent)=> (extend({
            properties: {
                data: {
                    status: parent.models['flow'].status,
                    w: parent.getWidth(),
                    h: parent.getHeight(),
                    bbox: parent.getBoundingBox()
                }
            },
            children: [
                (parent) => (extend({
                    properties: {
                        data: {
                            width: parent.data.w,
                            height: parent.data.h,
                            bbox: parent.data.bbox
                        }
                    }
                }, MapBlueprint) ),

                ThemeData,
                GeoData,
                (ctrl) => ( ctrl.data.status=='success'? []: BlueprintLoading )
            ]
        }, Group) )
    ]
};

let BlueprintLoading = [
    extend({
        properties:{
            attributes: {
                'x': 0,
                'y': 0,
                'width': (ctrl) => (ctrl.getControllerByUid('svg').getWidth() ),
                'height': (ctrl) => (ctrl.getControllerByUid('svg').getHeight(true) )
            },
            style: {
                fill: 'rgba(255,255,255,0.5)'
            }
        }
    },Rectangle),

    extend({
        properties: {
            attributes: {
                'cx': (ctrl) => ( 0.5 * ctrl.getControllerByUid('svg').getWidth() ),
                'cy': (ctrl) => ( 0.35 * ctrl.getControllerByUid('svg').getHeight(true) ),
            },
            data: { size: 30 }
        }    
    }, SvgLoader)
];

export default Blueprint;
export {Controller, Blueprint};

